import i18n from 'i18next';
import { registerValidator } from 'core/forms';

const isOffsetRequired = ({ fieldValue, model }) => {
  const isRequired = Boolean(model.timing);
  const amount = fieldValue?.amount;

  return {
    error: i18n.t('error-required-field-error'),
    hasError:
      isRequired && (amount === undefined || Number.isNaN(amount) || !fieldValue?.time_interval),
    isRequired,
  };
};

registerValidator('isOffsetRequired', isOffsetRequired);

export default isOffsetRequired;
